import visaLogo from "../../../Assets/card-networks/visa.png";
import mastercardLogo from "../../../Assets/card-networks/mastercard.png";
import amexLogo from "../../../Assets/card-networks/amex.png";

const ELO_VIEWBOX = "0 0 48 16";
const ELO_ASPECT = { width: 48, height: 16 };

const NetworkLogoSvg = ({
  viewBox,
  aspectWidth,
  aspectHeight,
  size = 28,
  className = "",
  children,
  "aria-label": ariaLabel,
  ...props
}) => (
  <svg
    viewBox={viewBox}
    preserveAspectRatio="xMidYMid meet"
    width={size}
    height={Math.round((size * aspectHeight) / aspectWidth)}
    className={`block h-auto max-w-full ${className}`.trim()}
    style={{ aspectRatio: `${aspectWidth} / ${aspectHeight}` }}
    role="img"
    aria-hidden={!ariaLabel}
    aria-label={ariaLabel}
    {...props}
  >
    {children}
  </svg>
);

const EloLogo = ({ size = 28, className = "", ...props }) => (
  <NetworkLogoSvg
    viewBox={ELO_VIEWBOX}
    aspectWidth={ELO_ASPECT.width}
    aspectHeight={ELO_ASPECT.height}
    size={size}
    className={className}
    {...props}
  >
    <rect x="0" y="2" width="14" height="12" rx="2" fill="#FFCB05" />
    <rect x="17" y="2" width="14" height="12" rx="2" fill="#00A4E0" />
    <rect x="34" y="2" width="14" height="12" rx="2" fill="#EF4123" />
    <text
      x="24"
      y="11.5"
      textAnchor="middle"
      fill="#231F20"
      fontSize="6"
      fontWeight="700"
      fontFamily="system-ui, sans-serif"
    >
      elo
    </text>
  </NetworkLogoSvg>
);

const NETWORK_IMAGE_LOGOS = {
  visa: { src: visaLogo, alt: "Visa", maxWidthFactor: 2 },
  mastercard: { src: mastercardLogo, alt: "Mastercard", maxWidthFactor: 1.35 },
  amex: { src: amexLogo, alt: "Amex", maxWidthFactor: 1.35 },
};

const ImageNetworkLogo = ({ src, alt, size, maxWidthFactor = 1.5, className = "" }) => (
  <img
    src={src}
    alt={alt}
    draggable={false}
    className={`block w-auto max-w-full object-contain ${className}`.trim()}
    style={{ height: size, maxWidth: Math.round(size * maxWidthFactor) }}
  />
);

const NETWORKS = {
  visa: { label: "Visa", type: "image", key: "visa" },
  mastercard: { label: "Mastercard", type: "image", key: "mastercard" },
  elo: { label: "Elo", type: "svg", Logo: EloLogo },
  amex: { label: "Amex", type: "image", key: "amex" },
  americanexpress: { label: "Amex", type: "image", key: "amex" },
};

export const getCardNetworkLabel = (network) => {
  const key = network?.toLowerCase?.();
  return NETWORKS[key]?.label ?? network;
};

export const CardNetworkLogo = ({
  network,
  size = 28,
  width,
  className = "",
  variant = "default",
}) => {
  const key = network?.toLowerCase?.();
  const entry = NETWORKS[key];

  if (!entry) {
    return null;
  }

  const logoWidth = width ?? size;

  if (entry.type === "image") {
    const imageMeta = NETWORK_IMAGE_LOGOS[entry.key];
    const isLightVariant = variant === "light" || variant === "black";

    return (
      <div className={`flex shrink-0 items-center justify-center ${className}`.trim()}>
        <ImageNetworkLogo
          src={imageMeta.src}
          alt={imageMeta.alt}
          size={logoWidth}
          maxWidthFactor={imageMeta.maxWidthFactor}
          className={isLightVariant && entry.key === "mastercard" ? "brightness-0 invert" : ""}
        />
      </div>
    );
  }

  const { Logo, label } = entry;

  return (
    <div
      className={`flex shrink-0 items-center justify-center ${className}`.trim()}
      style={{ width: logoWidth }}
    >
      <Logo size={logoWidth} variant={variant} aria-label={label} />
    </div>
  );
};
